/**
 * Words for a failed answer that carried no message of ours. A 5xx without our error body usually
 * means the server is down or restarting behind a proxy, and the request id (when the server sent one)
 * lets someone find the matching line in the server log.
 */
export function failureText(status: number, requestId: string | null, ownMessage: string | null): string {
  const reference = requestId ? ` Kode galat: ${requestId}.` : ''
  if (ownMessage) return status >= 500 ? `${ownMessage}${reference}` : ownMessage
  if (status >= 500) return `Server tidak dapat melayani permintaan (${status}). Periksa apakah server berjalan, lalu coba lagi.${reference}`
  return `Permintaan gagal (${status}).`
}
